import { Component, type ErrorInfo, type ReactNode } from "react";

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error: Error | null;
}

export default class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false, error: null };

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: ErrorInfo): void {
    console.error("ErrorBoundary caught an error:", error, info);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            width: "100vw",
            height: "100vh",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
            backgroundColor: "#FFF",
            color: "#213547",
            padding: "20px",
            gap: "16px",
          }}
        >
          <h1 style={{ margin: 0, fontSize: "24px" }}>
            Une erreur inattendue est survenue
          </h1>
          <p style={{ margin: 0, maxWidth: "500px", color: "#666" }}>
            L&apos;application a rencontré un problème. Veuillez recharger la
            page. Si le problème persiste, contactez le support.
          </p>
          {import.meta.env.DEV && this.state.error && (
            <pre
              style={{
                maxWidth: "80vw",
                overflow: "auto",
                background: "#f5f5f5",
                padding: "12px",
                borderRadius: "6px",
                fontSize: "12px",
                textAlign: "left",
              }}
            >
              {this.state.error.message}
              {"\n"}
              {this.state.error.stack}
            </pre>
          )}
          <button
            type="button"
            onClick={this.handleReload}
            style={{
              padding: "10px 24px",
              borderRadius: "30px",
              backgroundColor: "#E73A6E",
              color: "#FFF",
              border: "none",
              fontWeight: "bold",
              cursor: "pointer",
            }}
          >
            Recharger la page
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}
